<template>
    <div class="VestMgt spackage padding-20 bgc box-shado">
        <el-tabs v-model="activeName">
            <el-tab-pane label="马甲列表" name="vestlist">
                <VestList :innerid="innerid"></VestList>
            </el-tab-pane>
            <el-tab-pane label="发文章" name="postarticle">
                <PostArticle :innerid="innerid"></PostArticle>
            </el-tab-pane>
            <el-tab-pane label="发资料" name="postdata">
                <PostData :innerid="innerid"></PostData>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    import VestList from './starVest/VestList.vue'
    import PostArticle from './starVest/PostArticle.vue'
    import PostData from './starVest/PostData.vue'

    export default {
        name: "VestMgt",
        data() {
            return {
                innerid: this.$route.query.innerid,
                activeName: 'vestlist',
            }
        },
        components: {
            VestList,
            PostArticle,
            PostData
        }

    }
</script>

<style lang="scss" type="text/scss">
.VestMgt {

}
</style>
